"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setMailListRowsFlagState_1 = require("./setMailListRowsFlagState");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_list_store_1 = require("owa-mail-list-store");
/**
 * Get the flag status to be set
 * @param rowKeys the conversation rowkeys
 * @param tableViewId the table view
 * @return the flag status to be set
 */
function getFlagStatusToSet(rowKeys, tableView) {
    var flagStatus = 'NotFlagged';
    // Set the flag status to 'Flagged' if there is any non-flagged conversation
    for (var i = 0; i < rowKeys.length; i++) {
        var rowFlagStatus = owa_mail_list_store_1.MailRowDataPropertyGetter.getFlagStatus(rowKeys[i], tableView);
        if (rowFlagStatus != 'Flagged') {
            flagStatus = 'Flagged';
            break;
        }
    }
    return flagStatus;
}
/**
 * Toggle the given rows' flagged state
 * @param rowKeys the given rowkeys
 * @param tableViewId of the table that the row belong to
 */
exports.default = legacy_1.action('toggleRowsFlagState')(function toggleRowsFlagState(rowKeys, tableViewId) {
    var tableView = owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    var flagStatusToSet = getFlagStatusToSet(rowKeys, tableView);
    setMailListRowsFlagState_1.default(rowKeys, tableViewId, flagStatusToSet);
});
//# sourceMappingURL=toggleRowsFlagState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/toggleRowsFlagState.js
// module id = 5586
// module chunks = 62